module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "contentWrapper",
    staticClass: "content-wrapper",
    style: ('min-height: ' + _vm.alturaContentWrapper + 'px'),
    attrs: {
      "id": "liquidacoes"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Tratamento de Retorno'
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v(" Liquidação Financeira")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Retorno',
        href: '#'
      }, {
        text: 'Tratamento de Retorno',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('p', {
    staticClass: "visible-sm visible-xs nao_imprimir"
  }, [_vm._v(" ")]), _c('p', {
    staticClass: "visible-xs nao_imprimir"
  }, [_vm._v(" ")]), _c('p', {
    staticClass: "visible-xs nao_imprimir"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box box-widget nao_imprimir"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay box box-widget",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (_vm.loading.retornos) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.retornos,
      "multiple": false,
      "placeholder": "Selecione um lote de arquivos de Retorno",
      "label": "rotulo",
      "track-by": "numerador",
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "retorno",
      "value": _vm.usu_nomarq
    },
    on: {
      "input": _vm.buscarConteudoArquivoRetorno
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(props.option.usu_datoco === 'Data do retorno') ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_vm._v(_vm._s(props.option.usu_datoco))]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3 centralizar_elemento"
        }, [_vm._v("Arquivos")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3 centralizar_elemento"
        }, [_vm._v("Registros")])]) : _c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_vm._v(_vm._s(_vm._f("moment")(props.option.usu_datoco, "L")))]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3 centralizar_elemento"
        }, [_c('div', {
          staticClass: "contadorRegistros",
          domProps: {
            "innerHTML": _vm._s(props.option.ArquivosRetorno)
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3 centralizar_elemento"
        }, [_c('div', {
          staticClass: "contadorRegistros",
          domProps: {
            "innerHTML": _vm._s(props.option.QtdeRegistros)
          }
        })])])]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('div', {
          staticClass: "etiquetaRetorno"
        }, [_c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(_vm._f("moment")(props.option.usu_datoco, 'L')))]), _vm._v(" Arquivos: "), _c('span', {
          staticClass: "contadorRegistros"
        }, [_vm._v(_vm._s(props.option.ArquivosRetorno) + " ")]), _vm._v(" Registros: "), _c('span', {
          staticClass: "contadorRegistros"
        }, [_vm._v(_vm._s(props.option.QtdeRegistros) + " ")])])]
      }
    }]),
    model: {
      value: (_vm.retorno),
      callback: function($$v) {
        _vm.retorno = $$v
      },
      expression: "retorno"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1), _vm._v(" "), (_vm.processamentoRetorno.length > 0 && _vm._.get(_vm.retorno, 'usu_tiparq', 'PREVIA') !== 'PREVIA') ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true}"
    }],
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>Processará o(s) <span class=\'realce\'>' + (_vm.retorno.ArquivosRetorno) + '</span> arquivo(s) abaixo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processarRetorno()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" Processa retorno")])], 1) : _vm._e(), _vm._v(" "), (_vm.processamentoRetorno.length > 0) ? _c('span', [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.processamentoRetorno.length > 0) ? _c('div', {}, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "btn-group dropdown",
    staticStyle: {
      "padding": "6px 0"
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('span', {
    staticClass: "esmaecido",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                      Resumo: "), _c('span', {
    staticStyle: {
      "color": "var(--cor-azul)",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s((_vm._.keys(_vm._.groupBy(_vm.processamentoRetorno, 'usu_nomarq'))).length))]), _vm._v(" arquivo(s) "), _c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm._.groupBy(_vm.processamentoRetorno, 'usu_nomarq')), function(titulos, arquivo) {
    return _c('tr', {
      attrs: {
        "role": "menuitem"
      }
    }, [_c('td', [_vm._v(_vm._s(arquivo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(titulos[0].usu_tiparq))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((_vm._.filter(titulos, ['processamento', 1])).length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((_vm._.filter(titulos, ['processamento', 2])).length))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    staticStyle: {
      "font-style": "italic",
      "color": "var(--cor-fraca)"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total de "), _c('span', {
    staticStyle: {
      "color": "var(--cor-azul)"
    }
  }, [_vm._v(_vm._s(_vm.processamentoRetorno.length))]), _vm._v(" título(s)")]), _c('th', {
    staticStyle: {
      "color": "var(--cor-verde)"
    }
  }, [_vm._v(_vm._s((_vm._.filter(_vm.processamentoRetorno, ['processamento', 1])).length))]), _c('th', {
    staticStyle: {
      "color": "var(--cor-vermelha)"
    }
  }, [_vm._v(_vm._s((_vm._.filter(_vm.processamentoRetorno, ['processamento', 2])).length))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 pull-right"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordenacao.por),
      expression: "ordenacao.por"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "auto",
      "float": "left"
    },
    attrs: {
      "title": '<h5>Selecione por qual critério deseja ordenar</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ordenacao, "por", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "processamento"
    }
  }, [_vm._v("Com ou Sem Erros")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "usu_octban"
    }
  }, [_vm._v("Código Retorno")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "usu_nomarq"
    }
  }, [_vm._v("Arquivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "usu_numtit"
    }
  }, [_vm._v("Número do Título")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "numarb"
    }
  }, [_vm._v("Número da Remessa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vlrmov"
    }
  }, [_vm._v("Valor")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "btn btn-default btn-flat",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button",
      "title": '<h5>Clique para inverter a ordenação</h5>'
    },
    on: {
      "click": function($event) {
        _vm.ordenacao.ordem = _vm.ordenacao.ordem === 'asc' ? 'desc' : 'asc'
      }
    }
  }, [_c('i', {
    class: 'fa fa-sort-alpha-' + _vm.ordenacao.ordem,
    staticStyle: {
      "font-size": "14px"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.ordenacao.por === 'vlrmov' ?
    _vm._.orderBy(_vm.processamentoRetorno, [function(termo) {
      return parseFloat(termo[_vm.ordenacao.por])
    }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
    _vm._.orderBy(_vm.processamentoRetorno, [_vm.ordenacao.por], [_vm.ordenacao.ordem])), function(titulo) {
    return _c('div', {
      ref: titulo.usu_numtit + titulo.usu_codtpt + titulo.usu_codfor,
      refInFor: true,
      class: 'tarefa col-xs-12 ' + ('retornoProcessamento' + titulo.processamento)
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-3 col-xs-3",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('span', {
      staticClass: "indicadores"
    }, [_c('span', {
      staticClass: "text-muted",
      domProps: {
        "innerHTML": _vm._s(titulo.id)
      }
    }), _vm._v(" "), (_vm._.has(titulo, 'loading')) ? _c('p', {
      class: 'label label-' + titulo.loading.classe
    }, [_vm._v(_vm._s(titulo.loading.texto))]) : _c('p', {
      staticClass: "truncar",
      class: titulo.situacao === 'EM_EXECUCAO' ? 'text-green' : 'text-blue'
    }, [_vm._v(_vm._s(_vm.enumeradores[titulo.situacao]))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-3 col-md-5 col-sm-9 col-xs-9",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('div', {
      staticClass: "text-bold truncar"
    }, [_vm._v(_vm._s(titulo.usu_octban) + " - " + _vm._s(_vm._.get(_vm._.find(_vm.ocorrencias, ['OctBan', titulo.usu_octban]), 'DesBan', '')))]), _vm._v(" "), _c('div', {
      staticClass: "truncar"
    }, [_vm._v(" " + _vm._s(titulo.usu_desban))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-3 col-xs-5 alinha_vertical",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('div', {}, [_vm._v(_vm._s(titulo.usu_numtit))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(titulo.usu_codtpt))]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(titulo.usu_codfor))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-4 col-xs-7 alinha_vertical",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('div', [_c('span', {
      staticClass: "text-blue"
    }, [_vm._v(_vm._s(titulo.numarb))]), _vm._v(" / " + _vm._s(titulo.numcco))]), _vm._v(" "), _c('div', {
      staticClass: "truncar"
    }, [_vm._v(_vm._s(titulo.tippgt) + " - " + _vm._s(_vm.tiposPagamento[titulo.tippgt]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-4 col-sm-5 col-xs-5 alinha_vertical",
      staticStyle: {
        "height": "46px"
      }
    }, [(('' + titulo.codfpg) === '4') ? _c('div', {
      staticClass: "truncar"
    }, [_vm._v(_vm._s(titulo.codbar))]) : _c('div', [_vm._v(_vm._s(titulo.codban) + " "), _c('span', {
      staticClass: "esmaecido"
    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.codage) + " "), _c('span', {
      staticClass: "esmaecido"
    }, [_vm._v("/")]), _vm._v(" " + _vm._s(titulo.ccbfor))]), _vm._v(" "), _c('div', {
      staticClass: "truncar"
    }, [_vm._v(_vm._s(titulo.codfpg) + " - " + _vm._s(titulo.desfpg))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-3 col-sm-3 col-xs-7 alinha_vertical text-center",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('div', {
      staticClass: "esmaecido"
    }, [_vm._v(_vm._s(titulo.sittit))]), _vm._v(" "), (titulo.sittit === 'LQ' && (!_vm._.isNull(titulo.usu_autbb) || (_vm._.trim(titulo.usu_autban)).length > 5)) ? _c('div', {
      staticClass: "truncar"
    }, [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay:[500, 0]}"
      }],
      staticClass: "label label-default clicavel",
      attrs: {
        "title": '<h5>Autenticação bancária. Clique para gerar comprovante</h5>'
      },
      on: {
        "click": function($event) {
          _vm.emitir611(_vm._.trim(titulo.usu_numtit), _vm._.trim(titulo.usu_codfor))
        }
      }
    }, [_vm._v("\n                      " + _vm._s(!_vm._.isNull(titulo.usu_autbb) ? titulo.usu_autbb : (_vm._.trim(titulo.usu_autban)).length > 5 ? titulo.usu_autban : '') + "\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-3 col-sm-4 col-xs-7",
      staticStyle: {
        "height": "46px"
      }
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm._f("real")(titulo.vlrmov)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("real")(titulo.vlrliq)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-5 col-xs-5 text-right",
      staticStyle: {
        "height": "46px"
      }
    }, [(titulo.sittit !== 'LQ') ? _c('g-button-ujarak', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      attrs: {
        "color": "error",
        "size": "button--size-ss",
        "title": '<h5>Excluirá este títulos da remessa</h5>'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.excluirTituloArquivoRetorno(titulo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1), _vm._v(" "), (_vm._.has(titulo, 'retorno')) ? _c('div', {
      staticClass: "box-body"
    }, _vm._l((_vm._.get(titulo, 'retorno', [])), function(detalhe) {
      return _c('span', {
        class: 'label ' + (_vm._.includes(_vm._.toLower(detalhe.RDesBan), 'erro') ? 'label-danger' : (_vm._.isEmpty(_vm._.trim(detalhe.ROctBan)) ? 'label-warning' : 'label-success'))
      }, [_vm._v(_vm._s(detalhe.RDesBan)), _c('br')])
    }), 0) : _vm._e()])
  }), 0)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "w100 imprimir"
  }, [_c('tr', [_c('td', [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "direita"
  }, [_c('span', {
    staticStyle: {
      "font-size": "40px !important"
    }
  }, [_vm._v("Títulos Diversos")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Retorno de Pagamento Eletrônico")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Retornos...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('th', [_vm._v("Arquivo")]), _c('th', [_vm._v("Tipo")]), _c('th', [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "var(--cor-verde)",
      "font-weight": "bold"
    }
  })]), _c('th', [_c('i', {
    staticClass: "fa fa-ban",
    staticStyle: {
      "color": "var(--cor-vermelha)",
      "font-weight": "bold"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06d9adf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/remessas/TratamentoRetorno.vue
// module id = 1854
// module chunks = 1